<cap-horizontal-navbar [items]="navItems | filterByPermissions">
  <ng-template capTemplate="nav-item" let-item>
    <span [innerHtml]="item.title"></span>
  </ng-template>
</cap-horizontal-navbar>
